export const badgeOptions = [
  { value: null, label: 'None' }, 
  { value: 'cult_status', label: 'Cult Status' },
  { value: 'top_of_the_line', label: 'Top of the Line' },
  {
    value: 'best_bang_for_your_buck',
    label: 'Best Bang For Your Buck',
  },
  {
    value: 'crunchy_mom_approved',
    label: 'Crunchy Mom Approved',
  },
];
